import gql from 'graphql-tag';
import { getCounterpartyId } from '../../../services/authService';

export const getModulesQuery = gql`
	query {
		allModules(tenantId: "${getCounterpartyId()}") {
			moduleId
			id
			name
			code
			description
			tenantId
      isInternal
			privileges {
				id
				privilegeId
				code
				description
				displayName
				permissionType
				isMutuallyExclusive
				tenantId
			}
		}
	}
`;
